(function() {
  'use strict';

  function ImportarMercadoLivreCtrl($scope, $filter, $state, $uibModal, NgTableParams, MercadoLivre, Pedido, Encomenda) {
    var vmIML = this;
    var idPedido;
    var remessas = [];
    // variaveus publicas
    vmIML.alerts = [];
    vmIML.userData = 'minhaloja@gmail.com';
    vmIML.dataTabela = null;
    vmIML.showNenhumRegistro = null;
    vmIML.construindoTabela = true;

    function getEncomendasML() {
      // busca no back as remessas a serem importadas
      Encomenda
        .getPackages('mercadolivre')
        .then(function(data) {
          var data = data;
          vmIML.construindoTabela = null;

          for (var i = 0; i < data.length; i++) {
            data[i]['mandaeEmpacota'] = true;
            data[i]['observacao'] = null;
            data[i]['qrcodes'] = [];
          }

          vmIML.dataTabela = data;
          if (data.length) {
            constroiTabela();
          } else {
            vmIML.construindoTabela = null;
            vmIML.showNenhumRegistro = true;
          }

        })
        .catch(function(err) {
          $state.go('pedido.encomenda.adicionar');
        });
    }

    function getEmail() {
      MercadoLivre
        .getEmail()
        .then(function(userData) {
          vmIML.userData = userData;
          getEncomendasML();
        })
        .catch(getEncomendasML);
    }

    getEmail();

    // seta id do pedido se existir, id usado para criação ou não do pedido para add remessas importadas
    Pedido
      .getPedidoAsync()
      .then(function(data) {
        idPedido = data.id ? data.id : null;
        remessas = data.remessas || [];
      })
      .catch(function(err) {
        idPedido = null;
      });

    function constroiTabela(data) {
      var listaPedidos = data ? data : vmIML.dataTabela;

      vmIML.tableBasic = new NgTableParams({
        page: 1,
        count: listaPedidos.length
      }, {
        counts: [],
        total: listaPedidos.length,
        dataset: listaPedidos
      });
    }

    function verficarDuplicidade(itemsSelecionados) {
      var qrcodesString = [];
      var flag = true;

      for (var obj = 0; obj < itemsSelecionados.length; obj++) {
        forLinha: for (var valor = 0; valor < itemsSelecionados[obj].qrCodes.length; valor++) {
          forArray: for (var comparador = 0; comparador < qrcodesString.length; comparador++) {
            if (itemsSelecionados[obj].qrCodes[valor] == qrcodesString[comparador]) {
              vmIML.alerts.push({ type: 'danger', msg: 'O QR Code número ' + itemsSelecionados[obj].qrCodes[valor] + ' já existe.' });
              flag = false;
              break forLinha;
            }
          }
          qrcodesString.push(itemsSelecionados[obj].qrCodes[valor]);
        }
      }

      if (flag) {
        return true;
      }
    }

    // listener do checkbox do header onde seleciona ou não todos os itens da tabela
    vmIML.checkboxes = { 'checked': false };
    $scope.$watch('vmIML.checkboxes.checked', function(value) {
      if (angular.isDefined(vmIML.tableBasic)) {
        angular.forEach(vmIML.tableBasic.data, function(item, key) {
          if (angular.isDefined(item.mercadoLivrePedidoId)) {
            // seleciona todos ou não e reseta campos
            vmIML.tableBasic.data[key].checked = value;
            vmIML.tableBasic.data[key].mandaeEmpacota = true;
            vmIML.tableBasic.data[key].observacao = null;
            vmIML.tableBasic.data[key].qrcodes = [];
          }
        });
      }
    });

    function scrollToTop() {
      $('html, body').animate({ scrollTop: 0 }, 500);
    }

    // coleta os dados dos itens selecionados e envia para o servico
    vmIML.importar = function() {
      vmIML.alerts = [];
      var items = [];
      vmIML.carregandoEncomendas = null;

      var itemsSelecionados = $filter('filter')(vmIML.tableBasic.data, function(el) {
        if (el.checked) {
          var item = {};
          item.mercadoLivrePedidoId = el.mercadoLivrePedidoId;
          item.mandaeEmpacota = el.mandaeEmpacota;
          item.observacao = el.observacao;
          item.qrCodes = el.qrcodes.length > 0 ? el.qrcodes.replace(/\s/g, '').split(',') : [];
          items.push(item);
          return items;
        }
      });

      var itemsSalvar = {
        'mandaePedidoId': idPedido,
        'itens': items
      };

      if (itemsSelecionados.length > 0 && verficarDuplicidade(items)) {
        vmIML.carregandoEncomendas = true;
        Encomenda
          .savePackages('mercadolivre', itemsSalvar)
          .then(function(pedidoSalvo) {
            vmIML.carregandoEncomendas = null;
            var pedido = { remessas: remessas };
            for (var i = 0; i < itemsSelecionados.length; i++) {
              var encomenda = {
                servicoEnvio: 'PLP',
                qrCodes: itemsSelecionados[i].qrCodes,
                referencia: itemsSelecionados[i].mercadoLivrePedidoId
              };

              pedido.remessas.push(encomenda);
            }

            Pedido.getPedidoAsync(true, function() {
              $state.go('pedido.encomendas');
            });
          })
          .catch(function(err) {
            vmIML.carregandoEncomendas = null;
            if (err.data.error.code === "ML00003") {
              var msg = '';
              var numeroPedido;
              var listaPedidos = vmIML.dataTabela;
              var erroGenericoQrcode = false;
              var erroGenericoPedido = false;
              for (var i = 0; i < err.data.error.listaInformacoesAdicionais.length; i++) {
                for (var key in err.data.error.listaInformacoesAdicionais[i]) {
                  numeroPedido = key;

                  if (err.data.error.listaInformacoesAdicionais[i][key].MLVD01 != null) {
                    erroGenericoPedido = true;
                  }

                  if (err.data.error.listaInformacoesAdicionais[i][key].MLVD02 != null) {
                    erroGenericoQrcode = true;
                  }

                  for (var j = 0; j < vmIML.dataTabela.length; j++) {
                    if (listaPedidos[j].mercadoLivrePedidoId == key) {
                      listaPedidos[j].erroIdPedido = err.data.error.listaInformacoesAdicionais[i][key].MLVD01;
                      listaPedidos[j].erroQrCode = err.data.error.listaInformacoesAdicionais[i][key].MLVD02;
                      break;
                    }
                  };
                };

              }
              if (erroGenericoPedido) {
                vmIML.alerts.push({ type: 'danger', msg: 'Alguns pedidos não podem ser importados novamente. Desmarque esses pedidos da lista para continuar a importação.' })
              }
              if (erroGenericoQrcode) {
                vmIML.alerts.push({ type: 'danger', msg: 'Existem QrCodes que já estão em uso ou não foram encontrados.' })
              }
            } else {
              vmIML.alerts.push({ type: 'danger', msg: err.data.error.message })
            }
            scrollToTop();
          });
      } else if (itemsSelecionados.length == 0) {
        vmIML.alerts.push({ type: 'danger', msg: 'Nenhuma encomenda foi selecionada' })
        scrollToTop();
      }
    };

    vmIML.retiraErro = function(encomenda, type) {
      delete encomenda.erroQrCode;
    };

    vmIML.closeAlert = function(index) {
      vmIML.alerts.splice(index, 1);
    };

    vmIML.insereMsg = function() {
      alert('oi');
    };

    vmIML.exibirModalMl = function() {
      var modalInstance = $uibModal.open({
        animation: false,
        windowClass: 'modal-mercado-livre',
        template: require('../../common/integration-popover/mercado-livre.html'),
        controller: 'ModalMercadoLivreCtrl as vmML',
        resolve: {
          primeiraVez: false
        }
      });
    };

    vmIML.logout = function() {
      var modalInstance = $uibModal.open({
        animation: false,
        windowClass: 'modal-logout',
        templateUrl: 'modalLogoutML.html',
        controller: 'modalLogoutML as vmLogout',
        resolve: {
          emailML: function() {
            return vmIML.userData.ml_email;
          }
        }
      });
    };

  }

  function modalLogoutML($uibModalInstance, $state, MercadoLivre, emailML) {
    var vmLogout = this;

    vmLogout.logout = null;

    vmLogout.voltar = function() {
      $uibModalInstance.dismiss();
    };

    vmLogout.continuar = function() {
      vmLogout.logout = true;
      MercadoLivre.logoutML()
        .then(function() {
          vmLogout.logout = null;
          $state.go('adicionar');
          $uibModalInstance.dismiss();
        }).catch(function() {
          vmLogout.logout = null;
          $state.go('adicionar');
        });
    };
  }

  angular
    .module('mandaeApp')
    .controller('ImportarMercadoLivreCtrl', ImportarMercadoLivreCtrl)
    .controller('modalLogoutML', modalLogoutML);
})();
